/**
 * Free vs Starter, every row, below the two plan cards on /pricing/.
 *
 * ── IT REUSES /compare/'s MATRIX, IT DOES NOT INVENT ONE ────────────────────
 *
 * The pricing handoff and the compare handoff draw the same object: a floated
 * white card with the head row on the panel ground, top-rounded, and hairline
 * rules between rows. So this renders .uxa-cmp-matrix, built for /compare/,
 * with a three-column modifier -- one comparison table on this site, used on
 * two pages, rather than a second design that drifts from the first.
 *
 * Still a real <table>: <th scope="row"> on the feature and <th scope="col">
 * on each plan is what makes a screen reader say "PDF export and sprint
 * roadmap, Starter, Included" instead of reading unlabelled cells.
 *
 * The wrapper carries overflow-x, not the table: the table has a 720px
 * min-width so it forces the wrapper to scroll instead of squashing, and the
 * page body must never scroll sideways.
 *
 * ── THE ROWS ARE NOT WRITTEN HERE ───────────────────────────────────────────
 *
 * config/planFeatures.js is the single list, shared with the plan cards, and
 * pinned to backend/pricing.py by a test. A table that restated the cards
 * would be the seventh hand-typed copy of the feature list and would drift
 * from them the first time a number moved.
 */
import { PLAN_FEATURE_ROWS, NOT_INCLUDED } from '@/config/planFeatures';
import { PLAN_PRICES, CONTACT_TIERS } from '@/config/pricing';

export function PlanComparisonTable() {
  return (
    <section className="uxa-landing-section uxa-pt-xl" data-testid="plan-comparison">
      <h2 className="uxa-h2" style={{ textAlign: 'center', margin: 0 }}>
        Free vs Starter
      </h2>
      <p
        className="uxa-body"
        style={{ color: 'var(--ink-2)', margin: 'var(--space-4) auto 0', maxWidth: 560, textAlign: 'center' }}
      >
        Every row is the plan configuration as it currently ships, not a marketing summary.
      </p>
      <div className="uxa-cmp-matrix-card" style={{ maxWidth: 940, margin: 'var(--space-8) auto 0' }}>
        <table className="uxa-cmp-matrix uxa-cmp-matrix--plans">
          <thead>
            <tr>
              <th scope="col" className="uxa-cmp-matrix__lead">Feature</th>
              <th scope="col">
                Free
                <span style={{ color: 'var(--ink-2)', fontWeight: 'var(--type-weight-ui)' }}>
                  {` \u00b7 $${PLAN_PRICES.FREE.usd}`}
                </span>
              </th>
              <th scope="col" className="uxa-cmp-matrix__ours">
                Starter
                <span style={{ color: 'var(--ink-2)', fontWeight: 'var(--type-weight-ui)' }}>
                  {` \u00b7 $${PLAN_PRICES.STARTER.usd}/audit`}
                </span>
              </th>
              <th scope="col">
                Agency
                <span style={{ color: 'var(--ink-2)', fontWeight: 'var(--type-weight-ui)' }}>
                  {` \u00b7 $${CONTACT_TIERS.AGENCY.usd}${CONTACT_TIERS.AGENCY.period}`}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {PLAN_FEATURE_ROWS.map((r) => (
              <tr key={r.key}>
                <th scope="row">{r.label}</th>
                <td className={r.free === NOT_INCLUDED ? 'uxa-cmp-none' : undefined}>{r.free}</td>
                <td className="uxa-cmp-matrix__ours">{r.starter}</td>
                <td className={r.agency === NOT_INCLUDED ? 'uxa-cmp-none' : undefined}>{r.agency}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
